import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";

export const ManageAmericaCredentialForm = ({
  register
}: CredentialFormProps) => (
  <BaseInput
    id="manage_america_company_id"
    label="ManageAmerica Company ID"
    {...register("manage_america_company_id")}
    required
  />
);
